// extracted by mini-css-extract-plugin
module.exports = {"elem":"SignatorElem_elem__20k_8","empty":"SignatorElem_empty__1Jh4_","info":"SignatorElem_info__TlaEi"};